import React , { Component } from 'react';
import {Modal} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import Agent from "../../../Network/Agent";
import ToolBar from "../../../Components/Elements/ToolBar";
import {getGeneratedRoute, RouteEnumFinal} from "../../../Config/RouteEnum";
import {ActionButtonsEnum} from "../../../Components/Elements/BottomSheet/Enum/ActionButtonsEnum";
import BottomSheetAction from "../../../Components/Elements/BottomSheet/BottomSheetAction";
import BottomSheetConfirm from "../../../Components/Elements/BottomSheet/BottomSheetConfirm";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";



class CategoryListInternal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            storeUsername : window.location.host.split('.')[0],
            categories : [],
            modal : {
                actions : false,
                confirmDeleteCategory : false,
                editCategory : false,
                status : false,
                category : false
            },
            isLoading : {
                confirmDeleteCategory : false,
                editCategory : false,
                status : false,
                category: false
            },
            errors : {
                editCategory : null,
                category : null
            },
            underConstructionCategory : {},
            editingCategoryTitle : ""
        }
    }

    toggleModal = (target) => e => {
        let modal = this.state.modal
        modal[target] = !modal[target]
        this.setState({
            modal
        })
    }
    openActionsModalForCategory = (category) => e => {
        this.setState({
            underConstructionCategory : category,
            editingCategoryTitle : category.title,
            modal : {
                actions : true
            }
        })
    }
    onBottomSheetCallBack = (type , data) => {
        if (type === 'delete') {
            this.setState({
                modal : {
                    actions : false,
                    confirmDeleteCategory : true,
                }
            })
        }
        if (type === 'edit') {
            this.setState({
                modal : {
                    actions : false,
                    editCategory : true,
                }
            })
        }
        if (type === 'status') {
            this.setState({
                modal : {
                    status : true
                }
            })
        }
    }
    onBottomSheetConfirmDeleteCategoryCallBack = (type , data) => {
        if (type === 'positive') {
            this.setState({
                isLoading : {
                    confirmDeleteCategory : true
                }
            })
            Agent.Category.delete(data)
                .then(response => {
                    this.setState({
                        modal : {
                            confirmDeleteCategory : false
                        },
                        isLoading : {
                            confirmDeleteCategory : false
                        }
                    })
                    this.getCategoryList()
                })
                .catch(error => {
                    console.log(error.response)
                    this.setState({
                        isLoading : {
                            confirmDeleteCategory : false
                        }
                    })
                })
        }
        if (type === 'negative') {
            this.setState({
                modal : {
                    confirmDeleteCategory : false
                }
            })
        }
    }
    onChangeEditCategory = (e) => {
        let value = e.target.value
        this.setState({
            editingCategoryTitle : value
        })
    }
    onSubmitEditCategory = (e) => {
        e.preventDefault()
        this.setState({
            isLoading : {
                editCategory : true
            } ,
        })
        Agent.Category.update(this.state.underConstructionCategory.code , this.state.editingCategoryTitle)
            .then(response => {
                this.setState({
                    modal : {
                        editCategory : false
                    },
                    isLoading : {
                        editCategory : false
                    }
                })
                this.getCategoryList()
            })
            .catch(error => {
                console.log(error.response)
                this.setState({
                    isLoading : {
                        editCategory : false
                    },
                    error : {
                        editCategory : error.response.data.message
                    }
                })
            })
    }
    onBottomSheetStatusCategoryCallBack = (type , data) => {
        if (type === 'positive') {
            this.setState({
                isLoading : {
                    status : true
                }
            })
            Agent.Category.updateStatus(data)
                .then(response => {
                    this.setState({
                        modal : {
                            status : false
                        },
                        isLoading : {
                            status : false
                        }
                    })
                    this.getCategoryList()
                })
                .catch(error => {
                    console.log(error.response)
                    this.setState({
                        isLoading : {
                            status : false
                        }
                    })
                })
        }
        if (type === 'negative') {
            this.setState({
                modal : {
                    status : false
                }
            })
        }
    }
    submitCreateCategory = (e) => {
        e.preventDefault()
        let title = document.getElementById('input_category_title').value
        this.setState({
            isLoading : {
                category : true
            }
        })
        Agent.Category.create(this.state.storeUsername , title)
            .then(response => {
                let modal = {
                    menu : false,
                    category : false
                }
                this.setState({
                    isLoading : {
                        category : false
                    },
                    modal : modal,
                    errors : {
                        category : null
                    }
                })
                this.getCategoryList()
            })
            .catch(error => {
                this.setState({
                    isLoading : {
                        category : false
                    },
                    errors : {
                        category : error.response.data.message
                    }
                })
            })
    }

    getCategoryList = () => {
        Agent.Category.getListPanel(this.state.storeUsername)
            .then(response => {
                let categories = response.data.result.categories
                this.setState({
                    categories : categories
                })
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    componentDidMount() {
        this.getCategoryList()
    }

    render() {
        return (
            <>
                <ToolBar
                    customClasses={'box-shadow'}
                    title={'دسته بندی ها'}
                    navigate={this.props.toolbarNavigate}>
                    <div className="mobile-h4 desktop-h4 cl-blue">
                        <Link to={getGeneratedRoute(RouteEnumFinal.CATEGORY_LIST_SORTING_URL_GENERATE)}
                              className='each-fa-btn cl-blue td-none'>
                            ترتیب بندی
                        </Link>
                    </div>
                </ToolBar>

                <div className='container'>
                    <div className='row'>
                        {
                            this.state.categories.map(category => {
                                return(
                                    <div key={category.code} className='col-12'>
                                        <div className='d-flex justify-content-between align-items-center pt-20 pb-20'
                                             onClick={this.openActionsModalForCategory(category)}>
                                            <div className="mobile-h5 cl-black">
                                                { category.title }
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                {
                                                    category.status==="active"
                                                    ? <div className='mobile-body-1-strong cl-grass'>
                                                          فعال
                                                      </div>
                                                    : <div className='mobile-body-1-strong cl-tomato'>
                                                          غیر فعال
                                                      </div>
                                                }
                                                <div className='img-cnt-24 mr-16'>
                                                    <img src={"/assets/images/vectors/arrow_left_gray.svg"}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <section className='floating-action-btn left' style={{bottom : "20px"}}>
                    <div className='each-fa-btn'
                         style={{backgroundColor: "#000"}} onClick={this.toggleModal('category')}>
                        <FontAwesomeIcon icon={faPlus} style={{fontSize: '20px', color: "#FFF"}}/>
                    </div>
                </section>


                <Modal className='bottom-sheet fade in' show={this.state.modal.category} onHide={this.toggleModal('category')}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10' onClick={this.toggleModal('category')}>
                            <div className='bottom-sheet-close-line btn p-0 ' />
                        </div>

                        <div className='mobile-h5 cl-black mt-20'>
                            ایجاد دسته بندی جدید
                        </div>
                        <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                            برای ساختن دسته بندی جدید لطفا یک عنوان برای آن وارد کنید :
                        </div>

                        <form onSubmit={this.submitCreateCategory}>
                            <div className='form-group-input-primary mt-32'>
                                <label className="form-group-label">
                                    <input id='input_category_title'
                                           type="text"
                                           autoComplete="off"
                                           className={'form-group-input '+(this.state.errors.category===null ? "" : "hasError")}
                                           placeholder='عنوان دسته بندی : لباس مردانه'/>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {
                                            this.state.errors.category !== null
                                                ? this.state.errors.category
                                                : ''
                                        }
                                    </div>
                                </label>
                            </div>
                            <div className='mt-32'>
                                <ButtonPrimary text='ثبت'
                                               mode='dark-mode'
                                               isLoading={this.state.isLoading.category} />
                            </div>
                        </form>

                    </Modal.Body>
                </Modal>
                <BottomSheetAction show={this.state.modal.actions}
                                   onHide={this.toggleModal('actions')}
                                   data={this.state.underConstructionCategory.code}
                                   buttons={[
                                       ActionButtonsEnum.DELETE ,
                                       ActionButtonsEnum.EDIT ,
                                       ActionButtonsEnum.STATUS ,
                                   ]}
                                   action={this.onBottomSheetCallBack} />


                <BottomSheetConfirm show={this.state.modal.confirmDeleteCategory}
                                    onHide={this.toggleModal('confirmDeleteCategory')}
                                    title={"حذف دسته"}
                                    body='آیا از حذف این دسته بندی اطمینان دارید ؟'
                                    data={this.state.underConstructionCategory.code}
                                    action={this.onBottomSheetConfirmDeleteCategoryCallBack}
                                    isLoading={this.state.isLoading.confirmDeleteCategory}
                                    btnText='حذف' />

                <BottomSheetConfirm show={this.state.modal.status}
                                    onHide={this.toggleModal('status')}
                                    title={this.state.underConstructionCategory.status==="active" ? ("غیرفعالسازی دسته "+this.state.underConstructionCategory.title) : ("فعالسازی دسته "+this.state.underConstructionCategory.title)}
                                    body=''
                                    data={this.state.underConstructionCategory.code}
                                    action={this.onBottomSheetStatusCategoryCallBack}
                                    isLoading={this.state.isLoading.status}
                                    btnText={this.state.underConstructionCategory.status==="active" ? "غیرفعال" : "فعال"} />

                <Modal className='bottom-sheet fade in'
                       show={this.state.modal.editCategory}
                       onHide={this.toggleModal('editCategory')}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10' onClick={this.toggleModal('editCategory')}>
                            <div className='bottom-sheet-close-line btn p-0 ' />
                        </div>

                        <div className='mobile-h5 cl-black mt-20'>
                            تغییر عنوان دسته بندی
                        </div>
                        <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                            لطفا عنوان مورد نظر خود را بنویسید :
                        </div>

                        <form onSubmit={this.onSubmitEditCategory}>
                            <div className='form-group-input-primary mt-32'>
                                <label className="form-group-label">
                                    <input id='input_category_title'
                                           value={this.state.editingCategoryTitle}
                                           onChange={this.onChangeEditCategory}
                                           type="text"
                                           autoComplete="off"
                                           className={'form-group-input '+(this.state.errors.editCategory===null ? "" : "hasError")}
                                           placeholder='عنوان دسته بندی : لباس مردانه'/>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {
                                            this.state.errors.category !== null
                                                ? this.state.errors.category
                                                : ''
                                        }
                                    </div>
                                </label>
                            </div>
                            <div className='mt-32'>
                                <ButtonPrimary text='ثبت'
                                               mode='dark-mode'
                                               isLoading={this.state.isLoading.editCategory} />
                            </div>
                        </form>

                    </Modal.Body>
                </Modal>

            </>
        );
    }
}

const CategoryList = () => {
    const navigate = useNavigate()
    return <CategoryListInternal toolbarNavigate={() => navigate(-1)} />
}


export default CategoryList